import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { RevenueTypeListService } from '../../service/revenue-type-list/revenue-type-list.service';

@Component({
	selector: 'app-revenue-type-list',
	templateUrl: './revenue-type-list.component.html',
	providers: [
		RevenueTypeListService,
		HttpModule
	]
})
export class RevenueTypeListComponent implements OnInit {

	private token;
	public revenueTypes: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	revenueType: FormGroup;

	constructor(fb: FormBuilder, private revenueTypeListService: RevenueTypeListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.revenueType = fb.group({
			'Descricao': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchClientType(this.revenueType.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchClientType(this.revenueType.value, this.currentPage, false);
	}

	searchClientType(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.revenueTypeListService.searchRecipeType(this.token, value.Descricao, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			this.revenueTypes = result.Result;
			this.resultCount = result.Count;
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchClientType(this.revenueType.value, $event, false);
	}

}


// WEBPACK FOOTER //
// ./src/app/revenue-type/component/revenue-type-list/revenue-type-list.component.ts